import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaHome, FaSearch, FaMobileAlt, FaMapMarkedAlt, FaImages, FaEye, FaCalendarAlt, FaCode, FaRocket, FaUsers, FaEuroSign, FaShieldAlt, FaBuilding } from 'react-icons/fa';
import Button from '../../components/Button';

const WebInmobiliariasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: '/servicios/diseno-web-pymes', text: 'Páginas web baratas para PYMES' },
    { url: '/servicios/diseno-web-autonomos', text: 'Páginas web baratas para autónomos' },
    { url: '/servicios/diseno-web-abogados', text: 'Páginas web baratas para abogados' },
    { url: '/servicios/diseno-web-empresas', text: 'Páginas web baratas para empresas' },
    { url: '/servicios/diseno-web-restaurantes', text: 'Páginas web baratas para restaurantes' },
    { url: '/precios', text: 'Ver todos nuestros precios' }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Ahorra en comisiones de portales inmobiliarios",
      description: "Reduce tu dependencia de portales que te cobran altas comisiones. Con tu propia web, los clientes te contactan directamente y ahorras miles de euros al año."
    },
    {
      title: "Propiedades disponibles 24/7, incluso cuando no estás trabajando",
      description: "Tu web trabaja mientras duermes. Los interesados pueden ver todas tus propiedades a cualquier hora y solicitar información que recibirás por la mañana."
    },
    {
      title: "Capta tanto compradores como vendedores",
      description: "Una web profesional no solo atrae a quien busca comprar, sino también a propietarios que quieren vender con una agencia que se ve sólida y digital."
    },
    {
      title: "Destaca frente a inmobiliarias anticuadas",
      description: "Muchas inmobiliarias siguen trabajando a la antigua. Con una web moderna y funcional, transmites innovación y te diferencias inmediatamente de la competencia."
    },
    {
      title: "Posicionamiento local que atrae clientes de tu zona",
      description: "Optimizamos tu web para que aparezca cuando alguien busca 'inmobiliaria en [tu ciudad]', captando clientes locales que de otro modo irían a la competencia."
    },
    {
      title: "Inversión mínima, retorno máximo",
      description: "Con una sola venta o alquiler conseguido a través de la web, recuperas varias veces la inversión. La mayoría de nuestros clientes lo logran en los primeros meses."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaBuilding />,
      title: "Catálogo de propiedades que realmente vende",
      description: "No es un simple listado. Creamos fichas persuasivas con elementos estratégicos que destacan los beneficios de cada propiedad y motivan el contacto."
    },
    {
      icon: <FaSearch />,
      title: "Buscador intuitivo que retiene visitantes",
      description: "Incluimos filtros prácticos por zona, precio y características que facilitan la búsqueda y evitan que los usuarios abandonen tu web frustrados."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles (donde más buscan hoy)",
      description: "El 73% de búsquedas inmobiliarias se hacen desde el móvil. Tu web se adaptará a cualquier pantalla, mostrando perfectamente cada propiedad."
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Mapas integrados que aumentan el interés",
      description: "Mostrar la ubicación exacta incrementa un 60% las consultas. Incluimos mapas interactivos para cada propiedad, destacando puntos de interés cercanos."
    },
    {
      icon: <FaImages />,
      title: "Galerías de imágenes que impactan",
      description: "Las propiedades con buenas fotos reciben un 139% más de clics. Optimizamos tus fotos y las presentamos en galerías profesionales que seducen al visitante."
    },
    {
      icon: <FaEuroSign />,
      title: "Transparencia en precios = más confianza",
      description: "Precio final desde 300€ (pago único) y mantenimiento fijo de 20€/mes. Sin sorpresas ni costes ocultos que descubras después."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para agentes inmobiliarios o pequeñas inmobiliarias que necesitan una web profesional para comenzar.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por inmobiliarias. Equilibrio perfecto entre precio y funcionalidades para captar más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para inmobiliarias que quieren destacar con más funcionalidades y mejor posicionamiento en el sector.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión para entender tu negocio inmobiliario",
      description: "Hablamos sobre tu cartera actual, tipo de propiedades, zonas donde trabajas y qué te diferencia de otras inmobiliarias. Te explicamos todo el proceso sin jergas técnicas.",
      icon: <FaCalendarAlt />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web con un catálogo atractivo, funcionalidades inmobiliarias específicas y optimización para captar clientes. Te mostramos avances para asegurar que todo esté a tu gusto.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y formación básica",
      description: "Activamos tu web y te enseñamos a gestionar propiedades de manera sencilla. Te damos consejos para promocionarla y empezar a recibir consultas de potenciales clientes.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Web especializada en sector inmobiliario",
      us: true,
      others: false
    },
    {
      label: "Precio final sin sorpresas ni extras",
      us: true,
      others: false
    },
    {
      label: "Catálogo optimizado para convertir visitas",
      us: true,
      others: false
    },
    {
      label: "Sin comisiones por propiedades",
      us: true,
      others: false
    },
    {
      label: "Mantenimiento con precio fijo garantizado",
      us: true,
      others: false
    },
    {
      label: "Formación para gestionar tu web fácilmente",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Estaba cansada de depender de los portales inmobiliarios y sus continuas subidas de precios. Con mi web de Web a Bajo Coste, no solo ahorro en comisiones, sino que proyecto una imagen más profesional. En los primeros dos meses ya conseguí vender dos propiedades a través de la web.",
    author: "Laura Sánchez",
    position: "Directora",
    company: "Inmobiliaria Nuevo Hogar",
    avatar: "/servicios/testimonios/inmobiliaria.webp"
  };
  
  const founderMessage = "Tras analizar el sector inmobiliario, detectamos que la mayoría de agencias dependen demasiado de portales que les cobran comisiones cada vez más altas. Desarrollamos una solución específica para inmobiliarias que les permita independizarse digitalmente y construir su propia cartera de clientes online sin intermediarios.";
  
  // FAQs específicas para inmobiliarias
  const faqs = [
    {
      question: "¿Por qué necesito una web propia si ya uso portales inmobiliarios?",
      answer: "Los portales inmobiliarios son útiles pero costosos y no construyen tu marca. Una web propia complementa tu estrategia: reduce dependencia de comisiones externas (que pueden llegar a 300€ mensuales), crea imagen de marca propia, captura datos de contacto directamente, permite destacar tu valor diferencial como agencia y mejora tu presencia en búsquedas locales. La mayoría de nuestros clientes inmobiliarios reportan que la web se amortiza en menos de 6 meses solo por el ahorro en comisiones.",
      category: "Estrategia"
    },
    {
      question: "¿Podré actualizar yo mismo las propiedades o dependeré de vosotros?",
      answer: "Con nuestras webs para inmobiliarias (excepto el plan básico), incluimos un panel de administración intuitivo donde podrás añadir, modificar o eliminar propiedades fácilmente sin conocimientos técnicos. Te damos una breve formación de 30 minutos que será suficiente para que gestiones tu catálogo. Para quienes prefieren delegar, ofrecemos un servicio opcional de actualización donde nos envías los datos y nosotros hacemos los cambios por ti.",
      category: "Gestión"
    },
    {
      question: "¿La web generará contactos reales o es solo para 'estar en internet'?",
      answer: "Nuestras webs inmobiliarias están diseñadas específicamente para generar contactos. Incluimos elementos estratégicos como llamadas a la acción en cada propiedad, formularios simplificados, botones de WhatsApp visibles, y destacados de propiedades para aumentar las conversiones. Además, optimizamos la web para posicionamiento local, lo que atrae tráfico cualificado. En promedio, nuestros clientes inmobiliarios reciben entre 15-30 consultas mensuales a través de su web, dependiendo de su mercado local y volumen de propiedades.",
      category: "Resultados"
    },
    {
      question: "¿Cuántas propiedades puedo tener en la web y cómo se organizan?",
      answer: "Nuestros planes básico y profesional incluyen 30 y 100 propiedades respectivamente, mientras que el plan premium permite un número ilimitado. Las propiedades se organizan por categorías (venta/alquiler, tipo de inmueble, zona) para facilitar la navegación. Cada propiedad tiene su propia página detallada con fotos, descripción, características, mapa de ubicación y formulario de contacto específico. El sistema permite destacar propiedades en portada o marcarlas como 'Vendida' o 'Reservada' cuando corresponda.",
      category: "Funcionalidades"
    },
    {
      question: "¿Por qué vuestra web es mejor que las plantillas WordPress para inmobiliarias?",
      answer: "Aunque WordPress ofrece plantillas inmobiliarias, la mayoría requiere plugins adicionales de pago, mantenimiento constante, y tiene un rendimiento más lento. Nuestras webs inmobiliarias ofrecen ventajas clave: están desarrolladas con código limpio y tecnologías modernas (React) que aseguran mayor velocidad; incluyen todas las funcionalidades sin costes extras; tienen mejor posicionamiento al estar optimizadas específicamente para SEO local inmobiliario; no requieren actualizaciones constantes ni gestión técnica por tu parte; y vienen con soporte continuo incluido en el mantenimiento.",
      category: "Comparativa"
    },
    {
      question: "¿Cuánto tiempo tardará en estar lista mi web inmobiliaria?",
      answer: "El tiempo de desarrollo es de 10-14 días desde la aprobación del diseño inicial. Este plazo incluye: diseño personalizado según tu marca, implementación del catálogo y buscador de propiedades, integración del panel de administración, carga inicial de hasta 10 propiedades que nos proporciones (el resto podrás añadirlas tú mismo) y configuración de dominio y hosting. Para proyectos urgentes, ofrecemos un servicio express con entrega en 7 días con un pequeño suplemento.",
      category: "Plazos"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para inmobiliarias
      pageTitle="Página Web para Inmobiliarias desde 200€ | Sin Comisiones ni Sorpresas"
      pageDescription="Diseñamos webs para inmobiliarias que generan contactos reales sin depender de portales. Catálogo atractivo, mapas integrados y panel de gestión sencillo."
      pageKeywords="página web barata inmobiliarias, diseño web inmobiliario, web para vender pisos, web agente inmobiliario, web económica inmobiliarias"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-inmobiliarias"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para inmobiliarias desde 200€ (sin comisiones por propiedad)"
      heroSubtitle="Diseñamos páginas web que convierten visitas en clientes reales para tu inmobiliaria. Sin depender de portales, sin costes ocultos, lista en 14 días."
      heroImage="/servicios/tipo-cliente/inmobiliarias-hero.webp"
      badges={['Desde 200€ (pago único)', 'Sin comisiones por propiedad', 'Panel para gestión sencilla', 'Integrada con WhatsApp']}
      heroCTAText="Consulta gratuita sin compromiso"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de inmobiliaria"
      pricingSubtitle="Elige el plan que mejor se adapte a tu negocio. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son ideales para inmobiliarias?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Así creamos tu web inmobiliaria: simple, rápido y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué las inmobiliarias nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu inmobiliaria?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para inmobiliarias"
      faqCategories={["Estrategia", "Gestión", "Resultados", "Funcionalidades", "Comparativa", "Plazos"]}
      faqs={faqs}
      
      ctaTitle="Independízate de los portales inmobiliarios"
      ctaDescription="Deja de pagar comisiones y construye tu propia cartera de clientes online. Tu web inmobiliaria trabaja para ti 24/7."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebInmobiliariasPage; 

